
import React from "react";
import ReactExport from "react-data-export";
import {  Button
   } from '@material-ui/core';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
    render() {

        return (
            <ExcelFile 
                element={<Button variant="contained" color="secondary">Descargar</Button>}
                filename={this.props.filename}
            >
                <ExcelSheet data={this.props.voluntarios1} name="Primer Turno">
                    <ExcelColumn label="Cedula" value="cedula"/>    
                    <ExcelColumn label="Nombre" value="nombre"/>
                    <ExcelColumn label="Celular" value="celular"/>
                    <ExcelColumn label="Email" value="email"/>
                    <ExcelColumn label="Verificado" value="verificado"/>
                </ExcelSheet>
                <ExcelSheet data={this.props.voluntarios2} name="Segundo Turno">
                    <ExcelColumn label="Cedula" value="cedula"/>    
                    <ExcelColumn label="Nombre" value="nombre"/>
                    <ExcelColumn label="Celular" value="celular"/>
                    <ExcelColumn label="Email" value="email"/>
                    <ExcelColumn label="Verificado" value="verificado"/>
                </ExcelSheet>
                <ExcelSheet data={this.props.voluntarios3} name="Tercer Turno">
                    <ExcelColumn label="Cedula" value="cedula"/>    
                    <ExcelColumn label="Nombre" value="nombre"/>
                    <ExcelColumn label="Celular" value="celular"/>
                    <ExcelColumn label="Email" value="email"/>
                    <ExcelColumn label="Verificado" value="verificado"/>
                </ExcelSheet>
            </ExcelFile>
        );
    }
}


export default Download;